import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../_services/authentication.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {ModalController} from '@ionic/angular';
import {SaveMessage} from '../../../_helpers/save-message';
import {OrdinispedizioniService} from '../../../_services/ordinispedizioni.service';
import {OrdSped} from '../../../_models/OrdSped';
import {constants} from '../../../_helpers/constants';

@Component({
  selector: 'app-spedizione-esolver-launch',
  templateUrl: './spedizione-esolver-launch.component.html',
  styleUrls: ['./spedizione-esolver-launch.component.scss'],
  standalone: false
})
export class SpedizioneEsolverLaunchComponent implements OnInit {
  spedizione: OrdSped
  newSpedizione: OrdSped;
  loading = false;
  spedizioneUse: OrdSped;
  spedizioneInUse = false;
  today = new Date().getTime();
  constants = constants;

  constructor(
    public authService: AuthenticationService,
    private organizzazioniService: OrganizzazioniService,
    private spedizioniService: OrdinispedizioniService,
    private modalCtrl: ModalController,
    private saveMessage: SaveMessage) { }

  ngOnInit() {
    this.newSpedizione = {
      ...this.spedizione,
      statoSpedizione: 2,
      organizzazioneId: this.organizzazioniService.organizzazioneId
    };
  }

  createSpedizione(spedizione: OrdSped) {
    this.loading = true;
    this.spedizioniService.createOrdineSpedizione(spedizione)
      .then((_spedizione: OrdSped) => {
        const actor = this.organizzazioniService.codiceOperatore ?? this.authService.currentUserValue?.userName;
        const suffix = actor ? ` da ${actor}` : '';
        this.saveMessage.messageInfo(`Spedizione lanciata con successo${suffix}.`);
        this.modalCtrl.dismiss(_spedizione, 'confirm');
      })
      .catch(() => this.saveMessage.messageError("Problemi durante il lancio della spedizione."))
      .finally(() => this.loading = false);
  }

  updateSpedizione = () => {};

  cancel = () => this.modalCtrl.dismiss(false, 'cancel');

  isPastDate(value: unknown): boolean {
    if (!value) {
      return false;
    }
    return new Date(value as string | number | Date).getTime() < this.today;
  }
}
